export const customStyles = {
    header: {
        style: {
            minHeight: '56px',
            backgroundColor: '#f4f6f9'
        },
    },
    headRow: {
        style: {
            borderTopLeftRadius: '0.875rem',
            borderTopRightRadius: '0.875rem',
            borderBottom: '1px solid rgba(0,0,0,.12)',
            backgroundColor: '#f4f6f9'
        },
    },
    table: {
        style: {
            border: '1px solid rgba(0,0,0,.12)',
            borderBottom: 'none',
            borderTopLeftRadius: '0.875rem',
            borderTopRightRadius: '0.875rem',
            backgroundColor: '#f4f6f9'
        }
    },
    headCells: {
        style: {
            '&:not(:last-of-type)': {
                //borderRight: '1px solid rgba(0,0,0,.12)'
            },
            '&:last-child': {
                borderTopRightRadius: '0.875rem',
                width: '100%'
            },
            '&:first-child': {
                borderTopLeftRadius: '0.875rem',
            },
            '&:nth-child(2)': {
            //    placeContent: 'baseline',

            },
            backgroundColor: "#2d2180",
            fontSize: '0.8vw',
           // placeContent: 'center',
            color: 'white',
        },
    },
    cells: {
        style: {
            '&:not(:last-of-type)': {
                // borderRightStyle: 'solid',
                // borderRightWidth: '1px',
                // borderRightColor: 'rgba(164,167,181,1)',
                // borderRightRadius: '0.875rem',
                // borderRightStyle: 'solid',
                // borderRightWidth: '1px',
                // borderRightColor: 'rgba(0,0,0,.12)',
                // borderRightRadius: '0.875rem',
            }
        },
    },
    rows: {
        style: {
            '&:last-child': {
                // borderColor: 'rgba(0,0,0,.12)',
                // borderBottomRightRadius: '0.875rem',
                // borderBottomLeftRadius: '0.875rem',
            },
            '&:nth-child(even)': {
                backgroundColor: '#e3e9f1'
            },

            backgroundColor: '#f4f6f9',
            

        }
    },
    columns: {
        style: {
            '&:hover': {
                color: 'white',
            },
        },
    },
    pagination: {
        style: {
            backgroundColor: '#f4f6f9',
            borderStyle: 'solid',
            borderWidth: '1px',
            borderColor: 'rgba(0,0,0,.12)',
            borderBottomRightRadius: '0.875rem',
            borderBottomLeftRadius: '0.875rem',
        }
    },
    subHeader: {
        style: {
            backgroundColor: '#f4f6f9'
        }
    }
};